export default __webpack_public_path__ + "static/IBMPlexSans-Light-Latin1-bfefc1c5dd4c689b4f0f71167c6b1840.woff2";